var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.53063L12.6688 2.75524L12.6743 15.3306L0.0115039 15.4048L0 4.53075V4.53063ZM12.6628 16.7794L12.6725 29.3658L0.00980859 27.5742L0.00908203 16.695L12.6628 16.7794ZM14.1985 2.52283L30.9961 0V15.1706L14.1985 15.3077V2.52283ZM31 16.8978L30.996 32L14.1984 29.5603L14.1749 16.8695L31 16.8978Z",
    fill: "#100F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.3f803e3f3b37d319663b473fc7253453.svg";
export { ForwardRef as ReactComponent };